import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postOwner } from '../Api'

export default generateApiAction({
  baseType: Types.OWNERS.POST,
  api: postOwner,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/owners/PostAction.js